import { Card } from "react-bootstrap";
import "./infocard.css";
import useTranslator from "../../../hooks/useTranslator";

const InfoCard = ({ label, value, subvalue = "", className = "" }) => {
  const { _t } = useTranslator();

  return (
    <Card className={`mb-3 shadow-sm ${className}`}>
      <Card.Body className="infocard">
        <h5 className="subtitle">{_t(label, label)}</h5>
        <div className="d-flex justify-content-between">
          <p className="value mb-0">{value}</p>
          <p className="subvalue mb-0">{subvalue}</p>
        </div>
      </Card.Body>
    </Card>
  );
};

export default InfoCard;
